module.exports = __webpack_public_path__ + "static/risk-test-2-3b0eb0d500a92fc6c12e3d1f681a2c04.svg";